import { render, staticRenderFns } from "./unsolvePoint.vue?vue&type=template&id=63f8db6a&scoped=true"
import script from "./unsolvePoint.vue?vue&type=script&lang=js"
export * from "./unsolvePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8db6a",
  null
  
)

export default component.exports